<template>
  <el-dialog width="550px" :visible.sync="visible" title="退款" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" style="padding-right: 50px;" :rules="dataRule" ref="dataFormRefund" @keyup.enter.native="dataFormSubmitHandle()" label-width="120px" v-if="visible">
      <el-form-item prop="caName" label="企业名称">
          <el-input v-model="dataForm.caName" placeholder="企业名称" disabled></el-input>
      </el-form-item>
      <el-form-item prop="userCode" label="个人是否收款">
        <el-select v-model="dataForm.isReceived" placeholder="个人是否收款" @change="collectionListChange" clearable filterable :disabled="dataForm.isSee ? true : false">
          <el-option v-for="item in collectionList" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="nameOfRefunder" label="退款人姓名">
          <el-input v-model="dataForm.nameOfRefunder" placeholder="退款人姓名" :disabled="dataForm.isSee ? true : false"></el-input>
      </el-form-item>
      <el-form-item prop="idCardOfRefunder" label="退款人身份号码">
        <el-input v-model="dataForm.idCardOfRefunder" placeholder="退款人身份号码" :disabled="dataForm.isSee ? true : false"></el-input>
      </el-form-item>
      <el-form-item prop="reasonForRefund" label="退款原因" v-if="dataForm.isReceived == 1">
        <el-input v-model="dataForm.reasonForRefund" placeholder="退款原因" :disabled="dataForm.isSee ? true : false"></el-input>
      </el-form-item>
      <el-form-item prop="refundAmount" label="退款金额">
        <el-input v-model="dataForm.refundAmount" type="number" placeholder="退款金额" @input="handleInput" :disabled="dataForm.isSee ? true : false"></el-input>
      </el-form-item>
      <el-form-item prop="refundCertificate" label="退款证明">
        <el-upload class="upload-demo" :action="url" :on-remove="handleRemove" multiple :limit="1"
          :on-preview="handlePreview" :before-upload="beforeUploadHandle" :on-error="backerror"
          :on-success="successHandle" :file-list="dataForm.refundCertificate" :disabled="dataForm.isSee ? true : false">
          <el-button size="small" type="primary" v-if="dataForm.refundCertificate.length == 0" :disabled="dataForm.isSee ? true : false">上传附件</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item prop="refundVoucher" label="个人退款凭证" v-if="dataForm.isReceived == 1">
        <el-upload class="upload-demo" :action="url" :on-remove="handleRemove1" multiple :limit="1"
          :on-preview="handlePreview" :before-upload="beforeUploadHandle" :on-error="backerror"
          :on-success="successHandle1" :file-list="dataForm.refundVoucher" :disabled="dataForm.isSee ? true : false">
          <el-button size="small" type="primary" v-if="dataForm.refundVoucher.length == 0" :disabled="dataForm.isSee ? true : false">上传附件</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item prop="refundToEnterpriseVoucher" label="退款至企业凭证">
        <el-upload class="upload-demo" :action="url" :on-remove="handleRemove2" multiple :limit="1"
          :on-preview="handlePreview" :before-upload="beforeUploadHandle" :on-error="backerror"
          :on-success="successHandle2" :file-list="dataForm.refundToEnterpriseVoucher" :disabled="dataForm.isSee ? true : false">
          <el-button size="small" type="primary" v-if="dataForm.refundToEnterpriseVoucher.length == 0" :disabled="dataForm.isSee ? true : false">上传附件</el-button>
        </el-upload>
      </el-form-item>
	  
    </el-form>
    <template slot="footer" v-if="!dataForm.isSee">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()" :loading="loadingbut">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import Cookies from 'js-cookie'
import debounce from 'lodash/debounce'
import { isMobile,testPassword } from '@/utils/validate'
import aesJs from '../../../utils/login-aes'
export default {
  data () {
    return {
      url:`${window.SITE_CONFIG['apiURL']}/oss/file/upload2?access_token=${Cookies.get('access_token')}`,
      collectionList:[
        {value:1,label:'是'},
        {value:0,label:'否'},
      ],
      visible: false,
      roleList: [],
      roleIdListDefault: [],
	  loadingbut: false,
      dataForm: {
        id: '',
        caName:'',
        isReceived:1,
        nameOfRefunder:'',
        idCardOfRefunder:'',
        reasonForRefund:'',
        refundAmount:'',
        refundCertificate:[],
        refundVoucher:[],
        refundToEnterpriseVoucher:[],
      }
    }
  },
  computed: {
    dataRule () {
      var checkcard = (rule, value, callback) => {
        if (
          /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/.test(
            value
          )
        ) {
          callback();
        } else {
          callback(new Error("请输入身份证号"));
        }
      };
      return {
        nameOfRefunder:[{ required: true, message: '请输入退款人姓名', trigger: 'blur' }],
        idCardOfRefunder:[{ required: true, message: '请输入正确的退款人身份证号码',validator: checkcard, trigger: 'blur' }],
        reasonForRefund:[{ required: true, message: '请输入退款原因', trigger: 'change' }],
        refundAmount:[{ required: true, message: '请输入退款金额', trigger: 'blur' }],
        refundCertificate:[{ required: true, message: '请上传退款证明', trigger: 'change' }],
        refundVoucher:[{ required: true, message: '请上传个人退款凭证', trigger: 'blur' }],
        refundToEnterpriseVoucher:[{ required: true, message: '请上传退款至企业凭证', trigger: 'blur' }],
      }
    }
  },
  watch:{
    visible(newVal,oldVal){
      if(!newVal){
        this.dataForm.isReceived = 1;
      }
      this.$refs.dataFormRefund.resetFields()
      this.dataForm.refundCertificate=[];
      this.dataForm.refundVoucher=[];
      this.dataForm.refundToEnterpriseVoucher=[];
    }
  },
  methods: {
    handleInput(value) {
      if (value != '') {
          if (value.indexOf('.') > -1) {
                this.dataForm.refundAmount = value.slice(0, value.indexOf('.') + 3)
            } else { 
                this.dataForm.refundAmount = value
            }
      }
    },
    // 初始化
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataFormRefund.resetFields()
      })
      if(this.dataForm.isSee){
        this.getDetail();
      }
    },
    // 获取详情
    getDetail(){
      this.$http.get(`/sys/plat/refund/${this.dataForm.id}`).then(({ data: res }) => {
        console.log(res)
        if(res.code == 0){
          this.dataForm = {...this.dataForm,...res.data}
          console.log(this.dataForm)
            this.dataForm.refundCertificate = [{url:this.dataForm.refundCertificate,name:'退款证明'}];
            this.dataForm.refundVoucher = [{url:this.dataForm.refundVoucher,name:'个人退款凭证'}];
            this.dataForm.refundToEnterpriseVoucher = [{url:this.dataForm.refundToEnterpriseVoucher,name:'退款至企业凭证'}];
        }
      })
    },
    collectionListChange(e){
      this.$refs.dataFormRefund.resetFields()
      this.dataForm.refundCertificate=[];
      this.dataForm.refundVoucher=[];
      this.dataForm.refundToEnterpriseVoucher=[];
    },
    // 上传附件 
    handlePreview (file) {
      if (!file.url && !file.response.data.url) {
        this.$message.error('下载失败')
        return
      }
      const type = file.url || file.response.data.url.split('.')[4]
      // 判断文件类型
      if (type === 'doc' || type === 'docx' || type === 'xlsx' || type === 'xls' || type === 'ppt' || type ===
					'pptx') {
        // 在当前浏览器直接下载
        document.location.href = file.url || file.response.data.url
      } else {
        // 图片在浏览器打开 新的页面展示
        window.open(file.url || file.response.data.url, file.name)
      }
    },
    beforeUploadHandle (file) {
      console.log(file)
      if (file.type != 'application/pdf' && file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file
        .type !== 'image/png' && file.type !== 'image/gif' && file.type !== 'application/vnd.ms-excel' && file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.$message.error(this.$t('upload.tip', {
          'format': 'jpg、png、gif,pdf,xls,xlsx'
        }))
        return false
      }
      if (file.size / 1024 / 1024 > 30) {
        this.$message.error('文件太大，只能上传30MB以内的文件')
        return false
      }
      this.num++
    },
    backerror (e) {
      this.$message.error('文件上传失败，请重试')
    },
    // 上传成功
    successHandle (res, file, fileList) {
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }
      for (let i = 0; i < fileList.length; i++) {
        fileList[i].name = fileList[i].response.data.fileName + '.' + fileList[i].response.data.fileType
      }
      this.dataForm.refundCertificate = fileList
    },
    successHandle1 (res, file, fileList) {
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }
      for (let i = 0; i < fileList.length; i++) {
        fileList[i].name = fileList[i].response.data.fileName + '.' + fileList[i].response.data.fileType
      }
      this.dataForm.refundVoucher = fileList
    },
    successHandle2 (res, file, fileList) {
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }
      for (let i = 0; i < fileList.length; i++) {
        fileList[i].name = fileList[i].response.data.fileName + '.' + fileList[i].response.data.fileType
      }
      this.dataForm.refundToEnterpriseVoucher = fileList
    },
    handleRemove (file, fileList) {
      for (let i = 0; i < fileList.length; i++) {
        fileList[i].name = fileList[i].response.data.fileName + '.' + fileList[i].response.data.fileType
      }
      this.dataForm.refundCertificate = fileList
    },
    handleRemove1 (file, fileList) {
      for (let i = 0; i < fileList.length; i++) {
        fileList[i].name = fileList[i].response.data.fileName + '.' + fileList[i].response.data.fileType
      }
      this.dataForm.refundVoucher = fileList
    },
    handleRemove2 (file, fileList) {
      for (let i = 0; i < fileList.length; i++) {
        fileList[i].name = fileList[i].response.data.fileName + '.' + fileList[i].response.data.fileType
      }
      this.dataForm.refundToEnterpriseVoucher = fileList
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataFormRefund.validate((valid) => {
        if (!valid) {
          return false
        }
//        名称中的中文括号替换成英文括号
        this.loadingbut = true
        console.log(JSON.stringify(this.dataForm))
        let paramsForm = JSON.parse(JSON.stringify(this.dataForm));
        this.$http.post('/sys/plat/refund/save', {
          ...paramsForm,
          refundCertificate:this.dataForm.refundCertificate[0].response.data.url,
          refundVoucher:this.dataForm.refundVoucher.length > 0 ? this.dataForm.refundVoucher[0].response.data.url : '',
          refundToEnterpriseVoucher:this.dataForm.refundToEnterpriseVoucher[0].response.data.url,
        }).then(({ data: res }) => {
          this.loadingbut = false
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>

<style lang="scss" scoped>
// /deep/ .upload-demo{
//   display: flex !important;
// }
.mod-sys__user {
  .dept-list {
    .el-input__inner,
    .el-input__suffix {
      cursor: pointer;
    }
  }
  .role-list {
    .el-select {
      width: 100%;
    }
  }
}
</style>
